export default "__VITE_ASSET__BAdbuh0R__"